import { createSlice } from "@reduxjs/toolkit";

const assessmentTableSlice = createSlice({
  name: "assessment_data",
  initialState: { data: [] },
  reducers: {
    assessmentData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { assessmentData } = assessmentTableSlice.actions;

export default assessmentTableSlice.reducer;
